import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { AgGridColumnsSettingService } from '../ag-grid-columns-setting.service';
import { TabsService } from '../../tabs/tabs.service';
import { DisplayName } from 'src/app/shared/model/enum';
import { GridName } from 'src/app/shared/model/ag-grid-common-constant';
@Component({
  selector: 'app-sidebar-cell',
  templateUrl: './sidebar-cell.component.html',
  styleUrls: ['./sidebar-cell.component.scss']
})
export class SidebarCellComponent implements OnInit,ICellRendererAngularComp {
currentTab = ''
  params!: any;
  enumParams = DisplayName;
  gridName = GridName
  storageName: string = '';

  constructor(public agGridColumnsSettingService: AgGridColumnsSettingService,public tabService: TabsService ) {}
  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.storageName = params.context?.storageName || ''
  }
  refresh(params: ICellRendererParams<any, any>): boolean {
    return true;
  }

  ngOnInit(): void {
    this.tabService.currentTab.subscribe(res => {
      this.currentTab = res
    })
    if(!this.currentTab){
      this.currentTab = this.tabService.thisTab
    }
  }

  hideShowColumns(event, columnsName) {
    this.agGridColumnsSettingService.sidebarRow.next([{checked:event?.target?.checked,name: columnsName}]);
  }
  shouldDisplayDefault(): boolean {
    if (this.currentTab === 'vendor-list') {
      return this.isVendorListConditionMet();
    } else if (this.currentTab === 'company-recycle-bin' ||this.currentTab === 'companies') {
      return this.isCompanyConditionMet();
    }else if (this.currentTab === 'leads') {
      return this.isLeadConditionMet();
    }else if (this.currentTab === 'prospects') {
      return this.isProspectConditionMet();
    }else if (this.currentTab === 'contact-recycle-bin' ||this.currentTab === 'contacts' || this.currentTab === 'vendor-contact' ) {
      return this.isContactConditionMet();
    } else if (this.currentTab === 'requirements') {
      return this.isRequirementConditionMet();
    } else if (this.currentTab === 'vendor-parts-library') {
      return this.isVPLConditionMet();
    } else if (this.currentTab === 'oem-excess') {
      return this.isOEMExcessConditionMet();
    } else if (this.currentTab === 'parts-list') {
      return this.isPartsListConditionMet();
    } else if (this.storageName == GridName.REQUIREMENT_POTENTIAL_GRID) {
      return this.isRequirementPotentialConditionMet();
    } else if (this.storageName == GridName.REQUIREMENT_AVAILABLE_GRID) {
      return this.isRequirementAvailableConditionMet();
    } else if (this.storageName == GridName.REQUIREMENT_SOURCES_GRID) {
      return this.isRequirementApprovedConditionMet();
    }else if (this.storageName == GridName.SOURCING_POTENTIAL_GRID) {
      return this.isSourcingPotentialConditionMet();
    }else if (this.storageName == GridName.SOURCING_REQUIREMENT || this.storageName == GridName.SOURCING_BATCH_OVERVIEW) {
      return this.isSourcingRequirementConditionMet();
    }else if (this.storageName == GridName.SOURCING_SEND_RFQS_GRID) {
      return this.isSourcingSentRFQConditionMet();
    } else if (this.storageName == GridName.SOURCING) {
      return this.isSourcingConditionMet();
    } else {
      return this.defaultList();
    }
  }

  defaultList(): boolean {
    return  this.params.value === this.enumParams.STAGE ||
            this.params.value === this.enumParams.Active ||
            this.params.value === this.enumParams.RATING ||
            this.params.value === this.enumParams.TYPE ||
            this.params.value === this.enumParams.PHONE ||
            this.params.value === this.enumParams.DATECONTACTED ||
            this.params.value === this.enumParams.REVENUE ||
            this.params.value === this.enumParams.QUICKNOTES ||
            this.params.value === this.enumParams.ACTION ||
            this.params.value === this.enumParams.BY ;
  }  
      
  isVendorListConditionMet(): boolean {
    return  this.params.value === this.enumParams.Active ||
            this.params.value === this.enumParams.RATING ||
            this.params.value === this.enumParams.PHONE ||
            this.params.value === this.enumParams.VENDORTYPE ||
            this.params.value === this.enumParams.AVL ||
            this.params.value === this.enumParams.QUICKNOTES;
  }
  isCompanyConditionMet(): boolean {
    return  this.params.value === this.enumParams.STAGE ||
            this.params.value === this.enumParams.Active ||
            this.params.value === this.enumParams.RATING ||
            this.params.value === this.enumParams.TYPE ||
            this.params.value === this.enumParams.PHONE ||
            this.params.value === this.enumParams.DATECONTACTED ||
            this.params.value === this.enumParams.SALEPERSON ||
            this.params.value === this.enumParams.ALTERNATESALEPERSON ||
            this.params.value === this.enumParams.REVENUE ||
            this.params.value === this.enumParams.QUICKNOTES;
  }
  isLeadConditionMet(): boolean {
    return  this.params.value === this.enumParams.STAGE ||
            this.params.value === this.enumParams.Active ||
            this.params.value === this.enumParams.RATING ||
            this.params.value === this.enumParams.TYPE ||
            this.params.value === this.enumParams.PHONE ||
            this.params.value === this.enumParams.LEADSCORE ||
            this.params.value === this.enumParams.SALEPERSON ||
            this.params.value === this.enumParams.ALTERNATESALEPERSON ||
            this.params.value === this.enumParams.DATECONTACTED ||
            this.params.value === this.enumParams.REVENUE ||
            this.params.value === this.enumParams.QUICKNOTES;
  }
  isRequirementConditionMet(): boolean {
    return  this.params.value === this.enumParams.REQUIREMENT ||
    this.params.value === this.enumParams.REQDATE ||
    this.params.value === this.enumParams.STATUS ||
    this.params.value === this.enumParams.PARTNUMBER ||
    this.params.value === this.enumParams.CUSTOMERTARGET 
  }
  isProspectConditionMet(): boolean {
    return  this.params.value === this.enumParams.STAGE ||
            this.params.value === this.enumParams.Active ||
            this.params.value === this.enumParams.RATING ||
            this.params.value === this.enumParams.TYPE ||
            this.params.value === this.enumParams.PHONE ||
            this.params.value === this.enumParams.SALEPERSON ||
            this.params.value === this.enumParams.ALTERNATESALEPERSON ||
            this.params.value === this.enumParams.INTENTTOBUY ||
            this.params.value === this.enumParams.DATECONTACTED ||
            this.params.value === this.enumParams.REVENUE ||
            this.params.value === this.enumParams.QUICKNOTES;
  }
  isContactConditionMet(): boolean {
    return  this.params.value === this.enumParams.RATING ||
            this.params.value === this.enumParams.DEPARTMENT ||
            this.params.value === this.enumParams.LOCATION ||
            this.params.value === this.enumParams.TIMEZONE ||
            this.params.value === this.enumParams.TITLE ||
            this.params.value === this.enumParams.OFFICENUMBER ||
            this.params.value === this.enumParams.DIRECTNUMBER ||
            this.params.value === this.enumParams.MOBILENUMBER ||
            this.params.value === this.enumParams.EMAILADDRESS ||
            this.params.value === this.enumParams.DONOTCALL ||
            this.params.value === this.enumParams.DONOTEMAIL ||
            this.params.value === this.enumParams.LASTCONTACT ||
            this.params.value === this.enumParams.COMPANYNAME ||
            this.params.value === this.enumParams.Active ||
            this.params.value === this.enumParams.NEXTTASKDUEDATE ||
            this.params.value === this.enumParams.VENDOR_NAME

            ; 
  }
  isVPLConditionMet(): boolean {
    return this.params.value === this.enumParams.MANUFACTURER ||
           this.params.value === this.enumParams.VENDOR ||
           this.params.value === this.enumParams.VENDORCONTACT ||
           this.params.value === this.enumParams.EXPIRATIONDATE ||
           this.params.value === this.enumParams.ROHS ||
           this.params.value === this.enumParams.RATING ||
           this.params.value === this.enumParams.ACTIVE ;
  }
   isOEMExcessConditionMet():boolean{
    return this.params.value === this.enumParams.MANUFACTURER ||
           this.params.value === this.enumParams.CUSTOMER ||
           this.params.value === this.enumParams.CUSTOMER ||
           this.params.value === this.enumParams.CUSTOMERCONTACT||
           this.params.value === this.enumParams.EXPIRATIONDATE||
           this.params.value === this.enumParams.RATING ||
           this.params.value === this.enumParams.ROHS ||
           this.params.value === this.enumParams.ACTIVE ;
  }
  isPartsListConditionMet():boolean{
    return this.params.value === this.enumParams.MPN ||
           this.params.value === this.enumParams.MFR ||
           this.params.value === this.enumParams.ROHS ||
           this.params.value === this.enumParams.VENDOR ||
           this.params.value === this.enumParams.DATECODE ||
           this.params.value === this.enumParams.LOTCODE ||
           this.params.value === this.enumParams.CONSIGNMENT ||
           this.params.value === this.enumParams.QTY ||
           this.params.value === this.enumParams.OFFER ;
  }
  isRequirementPotentialConditionMet():boolean{
    return this.params.value === this.enumParams.DATE_OFFERED ||
           this.params.value === this.enumParams.STATUS ||
           this.params.value === this.enumParams.PARTNUMBER
  }
  isRequirementAvailableConditionMet():boolean{
    return this.params.value === this.enumParams.APPROVED ||
           this.params.value === this.enumParams.STATUS ||
           this.params.value === this.enumParams.PARTNUMBER
  }
  isRequirementApprovedConditionMet():boolean{
    return this.params.value === this.enumParams.PRIORITY ||
           this.params.value === this.enumParams.STATUS ||
           this.params.value === this.enumParams.PARTNUMBER
  }
  isSourcingRequirementConditionMet():boolean{
    return this.params.value === this.enumParams.REQ_NO ||
           this.params.value === this.enumParams.MPN ||
           this.params.value === this.enumParams.CUSTOMER ||
           this.params.value === this.enumParams.CONTACT ||
           this.params.value === this.enumParams.LINE_STATUS 
  }
  isSourcingPotentialConditionMet():boolean{
    return this.params.value === this.enumParams.DATE_OFFERED ||
           this.params.value === this.enumParams.STATUS ||
           this.params.value === this.enumParams.INCLUDE_IN_RFQ ||
           this.params.value === this.enumParams.PARTNUMBER
  }
  isSourcingSentRFQConditionMet():boolean{
    return this.params.value === this.enumParams.VENDOR_NAME ||
           this.params.value === this.enumParams.CONTACT ||
           this.params.value === this.enumParams.RESULT ||
           this.params.value === ''
  }
  isSourcingConditionMet():boolean{
    return this.params.value === this.enumParams.SB_NO ||
           this.params.value === this.enumParams.SALEPERSON ||
           this.params.value === this.enumParams.READY_TO_QUOTE ||
           this.params.value === this.enumParams.NO_BID
  }

  isVisible(params: any): boolean {
    const excludedValues = [
      this.enumParams.REQUIREMENT,
      this.enumParams.COMPANY,
      this.enumParams.CONTACT_NAME,
      this.enumParams.FULL_NAME,
      this.enumParams.VENDORCONTACT_NAME,
      this.enumParams.ALLOCATED_QTY,
      this.enumParams.CONSIGNED_QTY,
      this.enumParams.SB_NO
    ];
    const excludedUniqueNames = [
      'partNumber',
      'mpn',
      'status',
      'pendingStatus',
      'historyMessage',
      'certificationName',
      this.enumParams.VENDORNAME,
      this.enumParams.DATE_OFFERED,
      'offerStatus',
      'approved',
      'listDate',
      'alternativeMpn',
      'workOrdercompanyName',
      'files',
      'priority',
      'relatedReqMpn',
       'reqNo'
    ];
  if (params.value === this.enumParams.COMPANY && params.data.uniqueName === 'reqCompanyName') {
    return true;
  }
    return !excludedValues.includes(params.value) && !excludedUniqueNames.includes(params.data.uniqueName);
  }
  shouldShowElement(params: any): boolean {    
    const includedValues = [
      this.enumParams.REQUIREMENT,
      this.enumParams.COMPANY,
      this.enumParams.CONTACT_NAME,
      this.enumParams.FULL_NAME,
      this.enumParams.VENDORCONTACT_NAME,
      this.enumParams.ALLOCATED_QTY,
      this.enumParams.CONSIGNED_QTY,
      this.enumParams.SB_NO
    ];
  
    const includedUniqueNames = [
      'partNumber',
      'mpn',
      'status',
      'pendingStatus',
      'historyMessage',
      'certificationName',
      this.enumParams.VENDORNAME,
      this.enumParams.DATE_OFFERED,
      'approved',
      'offerStatus',
      'listDate',
      'alternativeMpn',
      'workOrdercompanyName',
      'files',
      'priority',
      'relatedReqMpn',
      'reqNo'
    ];
    if (params.value === this.enumParams.COMPANY && params.data.uniqueName === 'reqCompanyName') {
    return false;
  }
    return includedValues.includes(params.value) || includedUniqueNames.includes(params.data.uniqueName);
  }
  
}
